import Component from "react-pure-render/component";
import React from "react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";
import Modal from "../components/modal.react";
import InputWithError from "../components/inputWithError.react";
import FieldDragAndDrop from "./fieldDragAndDrop.react";
import SectionDragAndDrop from "./sectionDragAndDrop.react";
import EmptyDropTarget from "./emptyDropTarget.react";

export default class Template extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { actions, params: { uid } } = this.props;
    this.getTemplate(uid);
  }

  componentDidUpdate(prevProps) {
    const { params: { uid } } = this.props;
    const { params: { uid: prevUid } } = prevProps;
    if (uid !== prevUid) {
      this.getTemplate(uid);
    }
  }

  getTemplate = uid => {
    const { actions, notificationSystem } = this.props;

    actions.getTemplate(uid).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      }
    });

    actions.getTemplateSections(uid).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        payload.result.forEach(function(sectionUID, index) {
          actions.getSectionFields(sectionUID).then(({ error, payload }) => {
            if (error) {
              addNotificationsForInvalidFields(payload, notificationSystem);
            }
          });
          actions.getSectionGalleries(sectionUID).then(({ error, payload }) => {
            if (error) {
              addNotificationsForInvalidFields(payload, notificationSystem);
            }
          });
        });
      }
    });
  };

  dropAction = () => {
    const {
      settings: { draggingItemUID, hoveringItemUID },
      sections: { sections: { entities: sections } },
      actions,
      params: { uid },
      notificationSystem
    } = this.props;
    const dragField = sections.get(draggingItemUID);
    const dropField = sections.get(hoveringItemUID);
    actions
      .updateSection(sections.get(draggingItemUID), draggingItemUID)
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        }
        this.getTemplate(uid);
      });
  };

  generateEditPage = columnNumber => {
    const {
      settings: { draggingItemUID, hoveringItemUID },
      actions,
      params: { uid },
      templates: { templates: { entities: templates } },
      sections: {
        forms: {
          createSectionField,
          createSectionGallery,
          createSectionGallery: { isAddModalVisible: isAddGalleryModalVisible }
        },
        sections: {
          entities: sections,
          isEditModalVisible: isEditSectionModalVisible,
          isRemoveModalVisible: isRemoveSectionModalVisible
        }
      },
      fields: {
        fields: {
          entities: fields,
          isRemoveModalVisible: isRemoveFieldModalVisible,
          isAddModalVisible: isAddFieldModalVisible
        }
      },
      galleries: {
        galleries: {
          entities: galleries,
          isRemoveModalVisible: isRemoveGalleryModalVisible
        }
      },
      notificationSystem
    } = this.props;

    let content = null;
    const self = this;

    const addFieldFormProps = {
      actions: actions,
      feature: "sections",
      form: createSectionField,
      formName: "createSectionField",
      validateFormField: actions.validateFormFieldSections
    };

    const addGalleryFormProps = {
      actions: actions,
      feature: "sections",
      form: createSectionGallery,
      formName: "createSectionGallery",
      validateFormField: actions.validateFormFieldSections
    };
    let isEmpty = true;
    let sectionsHTML = null;
    if (templates.getIn([uid, "sections"])) {
      sectionsHTML = templates
        .getIn([uid, "sections"])
        .sort(
          (a, b) => sections.getIn([a, "sort"]) - sections.getIn([b, "sort"])
        )
        .map(function(section, sectionIndex) {
          section = sections.get(section);
          if (section.get("columnNumber") === columnNumber) {
            isEmpty = false;
            return (
              <SectionDragAndDrop
                uid={uid}
                itemUID={section.get("uid")}
                section={section}
                fields={fields}
                galleries={galleries}
                key={sectionIndex}
                dropAction={self.dropAction}
                hoveringItemUID={hoveringItemUID}
                setHoveringItemUID={actions.setHoveringItemUID}
                moveAction={actions.moveSection}
                types="section"
                setDraggingItemUID={actions.setDraggingItemUID}
                draggingItemUID={draggingItemUID}
                afterServerActionSuccess={self.getTemplate}
                actions={actions}
                notificationSystem={notificationSystem}
                isRemoveFieldModalVisible={isRemoveFieldModalVisible}
                isRemoveSectionModalVisible={isRemoveSectionModalVisible}
                isEditSectionModalVisible={isEditSectionModalVisible}
                isAddFieldModalVisible={isAddFieldModalVisible}
                addFieldFormProps={addFieldFormProps}
                isAddGalleryModalVisible={isAddGalleryModalVisible}
                addGalleryFormProps={addGalleryFormProps}
                isRemoveGalleryModalVisible={isRemoveGalleryModalVisible}
              />
            );
          }
        });
    }
    if (isEmpty) {
      return (
        <EmptyDropTarget
          hoveringItemUID={hoveringItemUID}
          setHoveringItemUID={actions.setHoveringItemUID}
          moveAction={actions.moveSection}
          types="section"
          itemUID={columnNumber.toString()}
        />
      );
    } else {
      return sectionsHTML;
    }
  };

  generateEditPageLeft = () => {
    return this.generateEditPage(1);
  };

  generateEditPageRight = () => {
    return this.generateEditPage(2);
  };

  publish = () => {
    const {
      actions,
      params: { uid },
      templates: { templates: { entities: templates } },
      sections: { sections: { entities: sections } },
      fields: { fields: { entities: fields } },
      galleries: { galleries: { entities: galleries } },
      notificationSystem
    } = this.props;
    templates.getIn([uid, "sections"]).map(function(section, sectionIndex) {
      sections.getIn([section, "fields"]).map(function(fieldUID, fieldIndex) {
        actions
          .updateField(fields.get(fieldUID), fieldUID)
          .then(({ error, payload }) => {
            if (error) {
              addNotificationsForInvalidFields(payload, notificationSystem);
            }
          });
      });
      sections
        .getIn([section, "galleries"])
        .map(function(galleryUID, galleryIndex) {
          actions
            .updateGallery(galleries.get(galleryUID), galleryUID)
            .then(({ error, payload }) => {
              if (error) {
                addNotificationsForInvalidFields(payload, notificationSystem);
              }
            });
        });
    });
  };

  openAddSectionModal = () => {
    const { actions, params: { uid } } = this.props;
    actions.setIsAddSectionModalVisible(uid);
  };

  closeAddSectionModal = () => {
    const { actions } = this.props;
    actions.setIsAddSectionModalVisible(false);
  };

  addSection = () => {
    const {
      actions,
      params: { uid },
      notificationSystem,
      templates: { forms: { createTemplateSection: { fields } } }
    } = this.props;
    let data = fields.toJS();
    data.sort = 1;
    actions.createTemplateSection(data, uid).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        this.getTemplate(uid);
      }
    });
    actions.setIsAddSectionModalVisible(false);
  };

  render() {
    const {
      actions,
      templates: {
        forms: {
          createTemplateSection,
          createTemplateSection: { isAddModalVisible }
        },
        templates: { entities: templates }
      },
      params: { uid }
    } = this.props;
    const contentLeft = this.generateEditPageLeft();
    const contentRight = this.generateEditPageRight();
    const addSectionFormProps = {
      actions: actions,
      feature: "templates",
      form: createTemplateSection,
      formName: "createTemplateSection",
      validateFormField: actions.validateFormFieldTemplates
    };

    return (
      <div className="islogged-page">
        <div className="row middle-xs">
          <h2 className="col-xs-8">{templates.getIn([uid, "name"])}</h2>
          <div className="col-xs-4">
            <button className="info" onClick={this.openAddSectionModal}>
              dodaj sekcję
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-8">{contentLeft}</div>
          <div className="col-xs-4">{contentRight}</div>
        </div>

        <div className="col-xs-12">
          <button className="success publish" onClick={this.publish}>
            zatwierdź
          </button>
        </div>
        {isAddModalVisible === uid && (
          <Modal
            closeModalAction={this.closeAddSectionModal}
            enterAction={this.addSection}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs middle-xs">
              <h3 className="col-xs-12">Dodaj pole</h3>
              <form className="col-xs-12">
                <div className="row middle-xs">
                  <label className="col-xs-12 col-sm-4">Nazwa pola</label>
                  <div className="col-xs-12 col-sm-8">
                    <InputWithError {...addSectionFormProps} field="name" />
                  </div>
                </div>
                <div className="row middle-xs">
                  <label className="col-xs-12 col-sm-4">Placeholder</label>
                  <div className="col-xs-12 col-sm-8">
                    <InputWithError
                      {...addSectionFormProps}
                      field="placeholder"
                    />
                  </div>
                </div>
              </form>
              <div className="col-xs-12">
                <button className="info" onClick={this.addSection}>
                  Dodaj
                </button>
                <button className="info" onClick={this.closeAddSectionModal}>
                  Anuluj
                </button>
              </div>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/template/template.react.js